import React, { useEffect } from "react";
import Footer from "./Essentials/Footer";
import Navbar from "./Essentials/Navbar";
import "./Css/Stylesheet.css";
import USER from "./ENV.json";
import quotes from "./Quotations.json";
import { useLocation, useNavigate } from "react-router-dom";

function Home() {
  var programming_images = [
    "education/java.png",
    "education/javascript.png",
    "education/python.png",
    "education/android.png",
    "education/fullstack.png",
    "education/html.png",
    "education/next.png",
    "education/react.png",
    "education/dsa.svg",
    "education/ruby.png",
    "education/golang.png",
    "education/mongo.png",
    "education/firebase.png",
    "education/c_sharp.png",
    "education/linux.png",
    "education/node.png",
    "education/css.png",
    "education/angular.png",
    "education/quantum.png"
  ];
  var location = useLocation();
  var navigate = useNavigate();
  const [isHovered, setIsHovered] = React.useState(false);

  useEffect(
    () => {
      const div = document.querySelector(".updateSection");
      let num = 0;
      const scrollToBottom = () => {
        if (!isHovered) {
          if (div.scrollTop + div.clientHeight >= div.scrollHeight) {
            div.scrollTop = 0;
            num = 0;
          } else {
            div.scrollTop = num;
            num += 0.5;
          }
        }
      };
      let intervalId;
      if (window.screen.width > 750)
        intervalId = setInterval(scrollToBottom, 20);
      div.addEventListener("mouseenter", () => setIsHovered(true));
      div.addEventListener("mouseleave", () => setIsHovered(false));
      return () => clearInterval(intervalId);
    },
    [isHovered]
  );
  useEffect(() => {
    if (localStorage.getItem("quote-sno") == undefined) {
      localStorage.setItem("quote-sno", 0);
    }
    var i = parseInt(localStorage.getItem("quote-sno"));
    if (location.pathname == "/" || location.pathname == "/index") {
      setInterval(() => {
        // if (!document.hasChildNodes("#quotes_content")) return;
        document.querySelector("#quotes_content").innerHTML =
          '"' + quotes.quotes[i % (quotes.quotes.length - 1)] + '"';
        i += 1;
        localStorage.setItem("quote-sno", parseInt(i));
      }, 20000);
    }
  }, []);
  var T = 0;
  useEffect(() => {
    let observer = new IntersectionObserver(Node => {
      Node.forEach(E => {
        if (E.isIntersecting) {
          setTimeout(() => {
            E.target.classList.remove("pop_from_down");
          }, (T += 20));
          observer.unobserve(E.target);
        }
      });
    });
    document.querySelectorAll(".card").forEach(Node => {
      observer.observe(Node);
    });
  }, []);
  T = 0;
  useEffect(() => {
    let observer = new IntersectionObserver(Node => {
      Node.forEach(E => {
        if (E.isIntersecting) {
          setTimeout(() => {
            if (E.target.classList.contains("pop_from_up")) {
              E.target.classList.remove("pop_from_up");
            }
          }, (T += 20));
          observer.unobserve(E.target);
        }
      });
    });
    document.querySelectorAll(".card").forEach(Node => {
      observer.observe(Node);
    });
  }, []);
  const [title, setTitle] = React.useState("");
  const [URL, setURL] = React.useState("");
  const [updates, setUpdates] = React.useState("");
  useEffect(() => {
    fetch("https://rohitpidishetty.github.io/NFRAC_Projects/Content.json")
      .then(res => res.json())
      .then(r => {
        setTitle(r.title);
        setURL(r.url);
      });
    fetch("https://rohitpidishetty.github.io/NFRAC_Projects/Updates.json")
      .then(res => res.json())
      .then(news => {
        setUpdates(news);
      });
  }, []);
  return (
    <div>
      <Navbar />
      <div>
        <iframe
          width="100%"
          height="498"
          src={URL}
          title={title}
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        />
      </div>
      <div className="highlights">
        <p>What's New</p>
        <div className="updateSection">
          {updates &&
            updates.news.map((news, idx) => {
              return (
                <p key={idx}
                  onClick={() => {
                    window.open(news.link, "_self");
                  }}
                  className="news"
                  style={{
                    cursor: 'pointer'
                  }}
                >
                  <p className="date">
                    {news.date}
                  </p>
                  <p className="title">
                    {news.title}
                  </p>
                </p>
              );
            })}
        </div>
      </div>
      <center className="content">
        <br />
        <br />
        <b>National Federation for Research in Advanced Computing (NFRAC)</b>
        <br />
        <br />
        <p style={{ marginTop: "10px", textAlign: "justify" }}>
          <b>NFRAC</b> was established by{" "}
          <b>
            Er. Pidishetty Rohit Vishwakarma Acharya (B.Tech(CSE), MS(CS
            Post-Grad))
          </b>{" "}
          on January 17 2020. NFRAC is all about enhancing the computer science
          technology and harnessing the tremendous computational power of the
          systems to use it to serve the technological needs of the current and
          future generations. It is all about innovations, new ideology,
          research and development of advanced and complex algorithms.
          <br />
          <br />
          We follow a four-step rule that is <b>THINK</b>, <b>LEARN</b>,{" "}
          <b>PRACTISE</b>, <b>IMPLEMENT</b>, <b>SUCCEED</b> and repeat the same
          in a loop. <br /> <b>THINK</b> differently, unlike others, THINK into
          the extremities of the subject and interrogate HOW it happened rather
          than WHY. On learning HOW, we can find an answer for WHY. You should
          start thinking precisely, figure out the pros and cons of your
          thoughts and reason out practically. Stay hungry to <b>LEARN</b>{" "}
          something new and simultaneously work on what you are learning. Set
          your goals for today, plan for tomorrow, learn from yesterday's
          mistakes and build yourself. Schedule your time table for what all you
          should be learning and working on for the day. <b>PRACTISE</b> what
          you have learnt, because practice makes you perfect. Try out every
          single method that you can with what you have learnt to make it happen
          in a better and efficient way.<br />
          <b>IMPLEMENT</b> it everyday and never stop working, not to be
          astonished, if you need to spend all your day on it. By following our
          four factors, you can make it to your success. Because <b>SUCCESS</b>{" "}
          is a long journey, in which you have been left with the power
          knowledge and time. So, use your time precisely and knowledge
          magnificently to record your success and celebrate your victory
          everyday that you have spent learning, as this is how you{" "}
          <b>SUCCEED</b>.
          <br />
          <br />
          Learning is an important factor to succeed. So, dont stop learning.
          Learn new things and work on them everyday to build new methodologies.
          Come up with a new invention everyday, don't stop trying things, try
          until you succeed but don't settle. -- Er. P. Rohit V. Acharya
        </p>
      </center>
      <br />
      <center className="details">
        <div className="Units">
          {/* NFRAC Units */}
          <center>
            <p>
              National Federation for Research in Advanced Computing (NFRAC)<br />{" "}
              Wings & Departments
            </p>
            <div>
              <div className="left">
                <p>NFRAC-Lab <br /> (Research & Development Wing)</p>
                <div>
                  <div
                    onClick={() => {
                      localStorage.setItem("departmentName", "AIRD");
                      localStorage.setItem(
                        "departmentImage",
                        "departments/aiimage.jpg"
                      );
                      window.open("department", "_self");
                    }}
                    className="card pop_from_down"
                  >
                    <img src="departments/aiimage.jpg" />
                    <p>AIRD department</p>
                  </div>
                  <div
                    onClick={() => {
                      localStorage.setItem("departmentName", "CSRD");
                      localStorage.setItem(
                        "departmentImage",
                        "departments/csimage.jpg"
                      );
                      window.open("department", "_self");
                    }}
                    className="card pop_from_down"
                  >
                    <img src="departments/csimage.jpg" />
                    <p>CSRD department</p>
                  </div>

                  <div
                    onClick={() => {
                      localStorage.setItem("departmentName", "VPLD");
                      localStorage.setItem(
                        "departmentImage",
                        "departments/vpld.png"
                      );
                      window.open("department", "_self");
                    }}
                    className="card pop_from_down"
                  >
                    <img src="departments/vpld.png" />
                    <p>VPLD department</p>
                  </div>
                  <div
                    onClick={() => {
                      localStorage.setItem("departmentName", "GPLD");
                      localStorage.setItem(
                        "departmentImage",
                        "departments/gpld.png"
                      );
                      window.open("department", "_self");
                    }}
                    className="card pop_from_down"
                  >
                    <img src="departments/gpld.png" />
                    <p>GPLD department</p>
                  </div>
                </div>
                <br />
                <p>
                  &#8226; Artificial Intelligence Research and Development (AIRD)
                </p>
                <p>
                  &#8226; Cyber Security Research and Development (CSRD)
                </p>
                <p>
                  &#8226; Veda Programming Language Development (VPLD)
                </p>
                <p>
                  &#8226; Garuda Programming Language Development (GPLD)
                </p>
              </div>
              <div className="right">
                <p>Viśvakarmān Technological Center <br /> (Engineering & Solutions Wing)</p>
                <div>
                  <div

                    onClick={() => {
                      localStorage.setItem("departmentName", "CSDC");
                      localStorage.setItem(
                        "departmentImage",
                        "departments/cpimage.png"
                      );
                      window.open("/viswakarman_technological_center", "_self");
                    }}


                    className="card pop_from_down"
                  >
                    <img src="vtc/dev.png" />
                    <p>VTC</p>
                  </div>

                </div>
                <br />

              </div>

              <div className="right">
                <p>ITTacademy <br /> (Training & Education Wing)</p>
                <div>
                  <div
                    onClick={() => {
                      window.open("nfrac_education", "_self");
                    }}
                    className="card pop_from_down"
                  >
                    <img src="education/java.png" />
                    <p>Java</p>
                  </div>
                  <div
                    onClick={() => {
                      window.open("nfrac_education", "_self");
                    }}
                    className="card pop_from_down"
                  >
                    <img src="education/python.png" />
                    <p>Python</p>
                  </div>
                  <div
                    onClick={() => {
                      window.open("nfrac_education", "_self");
                    }}
                    className="card pop_from_down"
                  >
                    <img src="education/fullstack.png" />
                    <p>Fullstack</p>
                  </div>
                  <div
                    onClick={() => {
                      window.open("nfrac_education", "_self");
                    }}
                    className="card pop_from_down"
                  >
                    <img src="education/c.png" />
                    <p>C</p>
                  </div>
                </div>
                <br />
                <div>
                  <div
                    onClick={() => {
                      window.open("nfrac_education", "_self");
                    }}
                    className="card pop_from_up"
                  >
                    <img src="education/android.png" />
                    <p>Android</p>
                  </div>
                  <div
                    onClick={() => {
                      window.open("nfrac_education", "_self");
                    }}
                    className="card pop_from_up"
                  >
                    <img src="education/react.png" />
                    <p>React</p>
                  </div>
                  <div
                    onClick={() => {
                      window.open("nfrac_education", "_self");
                    }}
                    className="card pop_from_up"
                  >
                    <img src="education/veda.png" />
                    <p>Veda</p>
                  </div>
                  <div
                    onClick={() => {
                      window.open("nfrac_education", "_self");
                    }}
                    className="card pop_from_up"
                  >
                    <img src="education/dsa.svg" />
                    <p>DSA</p>
                  </div>
                </div>
              </div>


            </div>
          </center>
        </div>
        <br />
        <center className="content">

          <p style={{ marginTop: "10px", textAlign: "justify" }}>
            <b>NFRAC</b> is structured into three principal wings: Research & Development, Engineering & Solutions and Training & Education. The Research and Development wing (NFRAC-Lab) serves as the autonomous core of NFRAC, comprising specialized departments including VPLD (Veda Programming Language Development), AIRD (Artificial Intelligence Research and Development), CSRD (Cyber Security Research and Development), and GPLD (Garuda Programming Language Development). This wing undertakes fundamental and applied research, develops core software, and designs tools and frameworks that support the operational activities of the VTC.<br /> The Engineering and Solutions wing - Viśvakarmān Technological Center (VTC) implements NFRAC-Lab's research outputs into end-to-end software solutions, managing both internal and client projects. Antar Systems focuses on developing in-house software that converts research findings into practical applications, while Vyapti Solutions delivers customized solutions tailored to client requirements.
            <br /> The Training and Education wing - Information Technology Traning Academy <a href="https://nfrac-in.web.app/nfrac_education">
              (ITTacademy)
            </a>, established as NFRAC-Edu on 16 December 2021, functions as an autonomous center focused on cultivating skilled engineers by providing structured education in programming and computer science, thereby preparing professionals to address the technological needs of the nation.
            <br /> Collectively, these autonomous and operational wings constitute an integrated ecosystem that advances research, technology development, product implementation, and human resource development in a coordinated and strategic manner.
          </p>
        </center>
        <br />
        <center className="rot_img">
          {/* Rotating images _START_ */}
          {window.screen.width > 750
            ? <div class="_Xgk23435jh___" id="__Gb234_">
              <div class="___Xkhh75__">
                <div class="_B2343H__Ju">
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="education/python.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="education/dsa.svg" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="education/html.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="education/javascript.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="education/react.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="education/next.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="/education/android.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="/education/java.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="/education/c.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="/education/firebase.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="/education/fullstack.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="education/golang.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="education/linux.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="education/node.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="education/quantum.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="education/veda.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="education/mongo.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="garuda/garuda.png" />
                  </figure>
                </div>
              </div>
            </div>
            : <div class="_Xgk23435jh___" id="__Gb234_">
              <div class="___Xkhh75__">
                <div class="_B2343H__Ju">
                  <figure tabindex="0" class="__c0ll___ __jbd97800__">
                    <img src="education/html.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="education/python.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="education/dsa.svg" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="education/java.png" />
                  </figure>
                  <figure tabindex="0" class="__c0ll___ ___6542dsd__">
                    <img src="education/javascript.png" />
                  </figure>
                </div>
              </div>
            </div>}
          {/* Rotating images _END_ */}
        </center>
        <br />
        <br />
        <br />
        <br />
        <br />
        <p
          style={{
            padding: window.screen.width < 750 ? "2%" : "2px"
          }}
        >
          <b>Reach out us:</b> nfrac.india@zohomail.com | 040-45038114
        </p>
        <p
          style={{
            padding: window.screen.width < 750 ? "2%" : "2px"
          }}
        >
          <b>Contact information: </b> rohitpidishetty@gmail.com |
          rohitpidishetty@icloud.com
        </p>
        <br />

        <p
          style={{
            padding: window.screen.width < 750 ? "2%" : "2px",
            fontSize: "1.15rem"
          }}
        >
          <i id="quotes_content">
            "Go beyond your imaginations, find what others cant,Do what others
            wont,Reach there, where rest never,<br /> Discover your self in a
            new corner of the universe...Parallel Universe exists!!"
          </i>
        </p>
        <p
          onClick={() => {
            navigate("/quotes");
          }}
        >
          <b
            style={{
              color: "blue",
              textDecoration: "underline",
              cursor: "pointer",
              padding: window.screen.width < 750 ? "2%" : "2px"
            }}
          >
            Read more quotes
          </b>
        </p>
        <br />
        <p
          style={{
            color: "blue",
            textDecoration: "underline",
            fontSize: "1.15rem",
            cursor: "pointer",
            padding: window.screen.width < 750 ? "2%" : "2px"
          }}
          onClick={() => {
            if (
              localStorage.getItem("session-id") != undefined &&
              localStorage.getItem("session-id") ==
              process.env.REACT_APP_SESSION_ID
            ) {
              window.open("messages", "_self");
            } else {
              var key = prompt("Enter the key");
              if (key != undefined && key.length != 0) {
                key = key.trim();
                if (key == USER.key) window.open("messages", "_self");
              }
            }
          }}
        >
          View Messages
        </p>
      </center>
      <Footer />
    </div>
  );
}

export default Home;
